import React from 'react';
import { CartProvider } from './src/context/cart'; // Adjust the import path as needed
import { Amplify, Auth } from "aws-amplify";
import awsExports from "./src/aws-exports";
import './src/pages/index.scss';
import { GatsbyImagesProvider } from './src/context/images';
import { LanguageProvider } from './src/i18n/LanguageContext';
Amplify.configure(awsExports);
Auth.configure(awsExports);

export const wrapPageElement = ({ element }) => {
    return <GatsbyImagesProvider>
        {element}
    </GatsbyImagesProvider>;

}
// Define the wrapRootElement function
export const wrapRootElement = ({ element }) => {
    return <LanguageProvider>
        <CartProvider>
            {element}
        </CartProvider>
    </LanguageProvider>;
};
